<ng-container *ngIf="tosItems">
  <div *ngFor="let item of tosItems; let i = index">
    <h4>
      {{ item.title }}
    </h4>
    <div class="video-container" *ngIf="item.videoType && item.url">
      <bepatient-video
        [video]="{ videoType: item.videoType, url: item.url }"
      ></bepatient-video>
    </div>
    <p [innerHtml]="item.excerpt"></p>
    <ion-button
      *ngIf="item.content"
      shape="round"
      fill="outline"
      (click)="selectItemIndex.emit(i)"
    >
      {{ item.buttonLabel ? item.buttonLabel : ('TOS.LEARN_MORE' | translate) }}
    </ion-button>
  </div>
</ng-container>
